export const Logo = () => {
  return (
    <>
      <a href="/">
        <img
          src="/images/logo/Logo.svg
        "
          alt="logo"
        />
      </a>
    </>
  );
};
